import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "./slider";
import Navbar55 from "./Navbar55";
import "./Home.css";
import { API } from "../../Utility/API";
import toast from "react-hot-toast";

import { FaFacebookF, FaTelegram, FaTwitter } from "react-icons/fa";
import { TfiYoutube } from "react-icons/tfi";
function Home() {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");

  const Contactus_API = async () => {
    try {
      let responce = await API?.post(`/contactus`, {
        name: name,
        email: email,
        mobile: mobile,
      });
      responce = responce.data.data;
      //console.log("contactusapi", responce);
      if (responce == "success") {
        toast.success(
          "Your request has been sent successfully. We will contact you soon !!"
        );
        setName("");
        setEmail("");
        setMobile("");
      } else {
        toast.error(responce);
      }
    } catch (e) {
      console.log("Error While calling Referrer API", e);
    }
  };

  useEffect(() => {
    sessionStorage.clear();
    // setImagePopupVisible(true);
  }, []);
  return (
    <div>
      {/* Navbar Add */}
      <Navbar55 />
      {/* Hero Section */}
      {/* <div className="container-fluid HerosectionTop">
      <div className="row">
          <div className="col-12">
            <ul className="headerlist">
              <li class="upper">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-up" aria-hidden="true"></i> )</span></li>
              <li class="lower">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-down" aria-hidden="true"></i> )</span></li>
              <li class="upper">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-up" aria-hidden="true"></i> )</span></li>
              <li class="lower">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-down" aria-hidden="true"></i> )</span></li>
              <li class="upper">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-up" aria-hidden="true"></i> )</span></li>
              <li class="lower">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-down" aria-hidden="true"></i> )</span></li>
              <li class="upper">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-up" aria-hidden="true"></i> )</span></li>
              <li class="lower">US30 394833.90 <span>(+0.93  <i className="fa fa-caret-down" aria-hidden="true"></i> )</span></li>
            </ul>
          </div>
        </div>
      </div> */}
      <div className="container-fluid Herosection">
        <div className="row h-100">
          <div className="col-12 h-100 px-0">
            <Slider />
            {/* <div className="card card-1 h-100 d-none">
              <div className="card-body h-100">
                <div className="row mx-0 h-100">
                  <div className="col-md-6 px-0 h-100 d-flex align-items-start justify-content-end flex-column h-100">
                    <div className="Heading">Trading for Anyone. Anywhere. Anytime.</div>
                    <p>Trade over 1000 Instruments. Forex, CFDs on Stock Indices, Commodities, Stocks, Metals and Energies.</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="card card-2 d-none">
              <div className="card-body">
                <div className="row mx-0 h-100">
                  <div className="col-md-8 h-100 d-flex align-items-start justify-content-center flex-column">
                    <div className="Heading">Trading for Anyone. Anywhere. Anytime.</div>
                    <p>Trade over 1000 Instruments. Forex, CFDs on Stock Indices, Commodities, Stocks, Metals and Energies.</p>
                    <a href="/Login" className="btn Herobtn">Login</a>
                  </div>
                </div>
              </div>
            </div>
            <div className="card card-3 d-none">
              <div className="card-body">
                <div className="row mx-0 h-100">
                  <div className="col-md-8 h-100 d-flex align-items-start justify-content-center flex-column">
                    <div className="Heading">Trading for Anyone. Anywhere. Anytime.</div>
                    <p>Trade over 1000 Instruments. Forex, CFDs on Stock Indices, Commodities, Stocks, Metals and Energies.</p>
                    <a href="/Login" className="btn Herobtn">Login</a>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </div>
        <div className="row py-5 g-3 d-none">
          <div className="col-12">
            <ul className="clients-list px-3">
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-1.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-2.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-3.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-4.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-5.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-6.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
              <li>
                <a href="/" className="Anker">
                  <img
                    src="/assets/imagesnew/clients-7.png"
                    alt=""
                    className="w-100 h-100"
                  />
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {/* Trading Accounts Section */}
      <div className="container-fluid py-5 Trading_Accounts">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-5">
              <div className="subHeading">account</div>
              <div className="Heading">Trading Accounts</div>
            </div>
          </div>
          <div className="row pt-5 g-5">
            <div className="col-lg-3">
              <div className="card">
                <div className="card-icon">
                  <i className="fa fa-building" aria-hidden="true"></i>
                </div>
                <div className="card-Heading">Professional Account</div>
                <p>
                  Traders with professional accounts gain access to a wide range
                  of benefits, including enhanced trading platforms
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card">
                <div className="card-icon">
                  <i className="fa fa-cogs" aria-hidden="true"></i>{" "}
                </div>
                <div className="card-Heading">Overview Account</div>
                <p>
                  The primary feature of a trading overview account is its
                  ability to aggregate information from multiple accounts and
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card">
                <div className="card-icon">
                  <i className="fa fa-hourglass-end" aria-hidden="true"></i>
                </div>
                <div className="card-Heading">Demo Account</div>
                <p>
                  Trading demo accounts are particularly valuable for novice
                  traders who are new to the world of investing.
                </p>
              </div>
            </div>
            <div className="col-lg-3">
              <div className="card">
                <div className="card-icon">
                  <i className="fa fa-university" aria-hidden="true"></i>
                </div>
                <div className="card-Heading">Regulation & Security</div>
                <p>
                  Ensure the broker is regulated by authorities like the FCA,
                  ASIC, or CFTC.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Who we are Section */}
      <div className="container-fluid whowearesection py-5">
        <div className="row align-items-center g-4">
          <div className="col-md-6">
            <div className="SubHeading">Account</div>
            <div className="Heading">Trading Accounts</div>
            <div className="accordion" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    {" "}
                    Is forex a good career?
                  </button>
                </h2>
                <div
                  id="collapseOne"
                  className="accordion-collapse collapse show"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                    Forex is the largest and most liquid market in the world. A career as a forex trader can be lucrative, flexible, and highly engaging. Forex traders face high risks, leverage, and volatility.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseTwo"
                    aria-expanded="false"
                    aria-controls="collapseTwo"
                  >
                   How much is 1 lot size?
                  </button>
                </h2>
                <div
                  id="collapseTwo"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                    In Forex trading, a standard lot size represents 100,000 units of the base currency being traded. This is the largest common lot size used in Forex transactions. For example, if you buy 1 standard lot of EUR/USD, you are buying 100,000 Euros. 
Here's a breakdown:
Standard Lot: 1.0 lot = 100,000 units of the base currency. 
Other Lot Sizes:
Mini Lot: 0.1 lot = 10,000 units. 
Micro Lot: 0.01 lot = 1,000 units. 
Nano Lot: 0.001 lot = 100 units.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    {" "}
                    Why is forex used?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                    Forex trading gives you the opportunity to trade a wide variety of currency pairs, trading on global events and the relative strength of major and minor economies. Our offering lets you trade over 80 currency pairs including: Major currency pairs like GBP/USD, EUR/USD, and USD/JPY.
                    </p>
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <button
                    className="accordion-button collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseThree"
                    aria-expanded="false"
                    aria-controls="collapseThree"
                  >
                    {" "}
                    What is a broker house?
                  </button>
                </h2>
                <div
                  id="collapseThree"
                  className="accordion-collapse collapse"
                  data-bs-parent="#accordionExample"
                >
                  <div className="accordion-body">
                    <p>
                    A brokerage firm or brokerage company is a middleman who connects buyers and sellers to complete a transaction for stock shares, bonds, options, and other financial instruments. Brokers are compensated in commissions or fees that are charged once the transaction has been completed.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <a href="/" className="whowearesectionimage">
              <img
                src="/assets/imagesnew/treadnggif.gif"
                className="w-100 h-100"
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      {/* cards section */}
      <div className="container-fluid py-5 smallcard">
        <div className="container">
          <div className="row">
            <div className="col-md-4 px-0">
              <div className="card">
                <div className="card-body">
                  <div className="cardheading">
                    150+ <span>Countries</span>
                  </div>
                  <p>
                    Trade policies and agreements shape the trading landscape of
                    countries
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 px-0">
              <div className="card">
                <div className="card-body">
                  <div className="cardheading">
                    40+ <span>Million Invest</span>
                  </div>
                  <p>
                    Investing a million dollars in trading represents a
                    significant opportunity and
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-4 px-0">
              <div className="card">
                <div className="card-body">
                  <div className="cardheading">
                    90+ <span>Awards</span>
                  </div>
                  <p>
                    Trading awards recognize excellence and achievement within
                    the financial
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* new content add */}
      <div className="container-fluid py-5 howITworks" id="About">
        <div className="row">
          <div className="col-12 pb-5 text-center">
            <div className="subHeading">The Process</div>
            <div className="Heading">About Us</div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6">
            <div className="howimage">
              <img
                className="w-100 h-100"
                src="/assets/imagesnew/aboutus.gif"
                alt="process"
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="card mb-3">
              <div className="card-body">
                <div className="card_Heading">
                  <span>1</span>What is Forex Trading?
                </div>
                <p>
                  Forex trading involves buying and selling currencies to profit
                  from price fluctuations. It operates 24/5, requiring knowledge
                  of market trends and risk management.
                </p>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="card_Heading">
                  <span>2</span>Major Currency Pairs in Forex
                </div>
                <p>
                  Major pairs like EUR/USD and GBP/USD have high liquidity.
                  Understanding their movements and economic influences helps
                  traders make informed decisions and maximize profits.
                </p>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="card_Heading">
                  <span>3</span>Forex Trading Strategies
                </div>
                <p>
                  Popular strategies include scalping, day trading, and swing
                  trading. Using technical and fundamental analysis helps
                  traders predict price movements and execute profitable trades.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* How It Works */}
      <div className="container-fluid py-5 howITworks">
        <div className="row">
          <div className="col-12 pb-5 text-center">
            <div className="subHeading">The Process</div>
            <div className="Heading">How It Works</div>
          </div>
        </div>
        <div className="row align-items-center">
          <div className="col-md-6 order-md-1 order-2">
            <div className="card mb-3">
              <div className="card-body">
                <div className="card_Heading">
                  <span>1</span>Sign up, It's Free!
                </div>
                <p>
                  Our team will set up your account and help you build job to
                  easy-to-use web dashboard.
                </p>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="card_Heading">
                  <span>2</span>Find best Deals and Invest
                </div>
                <p>
                  Create and Trade anywhere from 1-100% openings with just a few
                  clicks. customize your own.
                </p>
              </div>
            </div>
            <div className="card mb-3">
              <div className="card-body">
                <div className="card_Heading">
                  <span>3</span>Get you profit back
                </div>
                <p>
                  View market, reviews, and rosters before forex arrive on the
                  site, and post reviews and pay, effortlessly.
                </p>
              </div>
            </div>
          </div>
          <div className="col-md-6 order-md-2 order-1">
            <div className="howimage">
              <img
                className="w-100 h-100"
                src="/assets/imagesnew/process-1.jpg"
                alt="process"
              />
            </div>
          </div>
        </div>
      </div>
      {/* Latest News Update start */}
      <div className="container-fluid py-5 newsupdate" id="Blog">
        <div className="row">
          <div className="col-12 pb-5 text-center">
            <div className="subHeading">Media Center</div>
            <div className="Heading">Latest News Update</div>
          </div>
        </div>
        <div className="row g-3">
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body">
                {/* <div className="cardsubHeading">25TH Dec, 2024</div> */}
                <div className="card_Heading">
                  NZD/USD: Trade Wars, Not Rate Cuts, Are Calling the Shots
                </div>
                <p>
                  The Reserve Bank of New Zealand (RBNZ) says monetary policy
                  remains in restrictive territory despite slashing interest
                  rates by 125bps this cycle, implying there will be a need to
                  continue reducing the overnight cash rate if inflation
                  continues to subside. Its estimate for the range where
                  interest rates keep unemployment and inflation stable are
                  slightly lower than where markets expect the cash rate to
                  bottom this cycle, suggesting the aggressive cuts seen over
                  the past two meetings may extend well into 2025 should there
                  be no evidence of a pickup in the economy.
                </p>
                <a href="/">Read More</a>
              </div>
              {/* <div className="card-footer">
                  <div className="icontext"><span><img src="/assets/imagesnew/testimonial-1.png" className="w-100 h-100" alt="" /></span>Daniel Marcon</div>
                </div> */}
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body">
                {/* <div className="cardsubHeading">11TH Jan, 2025</div> */}
                <div className="card_Heading">
                  USD/JPY Outlook Hinges on Federal Reserve Rate Decision
                </div>
                <p>
                  Chinese manufacturing and non-manufacturing PMIs fell short of
                  expectations on Monday, with the manufacturing PMI dropping to
                  a five-month low of 49.1, signaling contraction. Following a
                  brief rebound from the $80 level, driven by factors such as
                  Trump’s oil price cut claims and the dissipation of short-term
                  bullish drivers, crude oil wiped out nearly all of its 2025
                  gains, sliding back to the $72 price zone.
                </p>
                <a href="/">Read More</a>
              </div>
              {/* <div className="card-footer">
                  <div className="icontext"><span><img src="/assets/imagesnew/testimonial-1.png" className="w-100 h-100" alt="" /></span>Daniel Marcon</div>
                </div> */}
            </div>
          </div>
          <div className="col-md-4">
            <div className="card h-100">
              <div className="card-body">
                {/* <div className="cardsubHeading">19TH Jan, 2024</div> */}
                <div className="card_Heading">
                  Gold Forecast: XAU/USD Approaches All-Time Highs
                </div>
                <p>
                  Since Trump’s inauguration on January 20, the dollar has faced
                  a significant wave of selling pressure, attributed to
                  uncertainty surrounding the new tariffs the president plans to
                  impose on several countries. The market remains uncertain
                  about whether these measures will create competitive economic
                  advantages for the United States. For now, investors have
                  opted to seek refuge in currencies like the euro and yen. This
                  shift has substantially reduced demand for the dollar in the
                  short term.
                </p>
                <a href="/">Read More</a>
              </div>
              {/* <div className="card-footer">
                  <div className="icontext"><span><img src="/assets/imagesnew/testimonial-1.png" className="w-100 h-100" alt="" /></span>Daniel Marcon</div>
                </div> */}
            </div>
          </div>
        </div>
      </div>
      {/* Contact us Section */}
      <div className="container-fluid contactus py-5" id="Contact">
        <div className="container">
          <div className="row">
            <div className="Subheading">24/7 Contact</div>
            <div className="Heading mb-5">Contact Us</div>
          </div>
          <div className="row align-items-center">
            <div className="col-md-6">
              <div className="contactusimage">
                <img
                  src="/assets/imagesnew/contactus.jpg"
                  alt=""
                  className="w-100 h-100"
                />
              </div>
            </div>
            <div className="col-md-6">
              <form action="" className="row mx-0 g-3">
                <div class="col-12">
                  <label htmlFor="Name" class="form-label">
                    Name
                  </label>
                  <input
                    type="text"
                    class="form-control shadow-none"
                    id="Name"
                    placeholder="Enter Your Name"
                    onChange={(e) => setName(e.target.value)}
                    value={name}
                  />
                </div>
                <div class="col-12">
                  <label for="Email" class="form-label">
                    Email
                  </label>
                  <input
                    type="Email"
                    class="form-control shadow-none"
                    id="Email"
                    placeholder="Enter Your Email"
                    onChange={(e) => setEmail(e.target.value)}
                    value={email}
                  />
                </div>
                <div class="col-12">
                  <label for="Number" class="form-label">
                    Number
                  </label>
                  <input
                    type="number"
                    class="form-control shadow-none"
                    id="Number"
                    placeholder="Enter Your Number"
                    onChange={(e) => setMobile(e.target.value)}
                    value={mobile}
                  />
                </div>
                <div className="col-12">
                  <button
                    type="button"
                    className="btn px-4 py-2"
                    onClick={() => Contactus_API()}
                  >
                    Submit
                  </button>
                </div>
              </form>
              <p className="text-uppercase">
                <span>A2ZFX pvt.ltd</span>
              </p>
              <p className="addresh">
                <span>Registration office:</span> OFFICE 1401 - 22 WEALD HALL
                LANE THORNWOOD EPPING ENGLAND CM16 6NB
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Footer Section start */}
      <div className="container-fluid py-5 footer">
        <div className="container">
          <div className="row g-3">
            <div className="col-lg-3 col-md-6">
              <a href="" className="footerlogo">
                <img
                  className="w-100 h-100"
                  src="assets/imagesnew/Navbar/logo.png"
                  alt=""
                />
              </a>{" "}
              <br />
              <a href="" className="mail">
                info@a2zfx.trade
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footerheading">Important Links</div>
              <a href="" className="Anker">
                Home
              </a>
              <a href="" className="Anker">
                About US
              </a>
              <a href="" className="Anker">
                Blog
              </a>
              <a href="" className="Anker">
                Contact
              </a>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footerheading">Subscribe</div>
              <div className="inputmail">
                <input
                  type="text"
                  className="form-control"
                  placeholder="info@a2zfx.trade"
                />
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="footerheading">Social</div>
              <ul className="Sociallist">
                <li>
                  <a href="">
                    <img
                      src="assets/imagesnew/facebook.png"
                      className="w-100 h-100"
                      alt=""
                    />
                  </a>
                </li>
                <li>
                  <a href="">
                    <img
                      src="assets/imagesnew/instagram.png"
                      className="w-100 h-100"
                      alt=""
                    />
                  </a>
                </li>
                <li>
                  <a href="">
                    <img
                      src="assets/imagesnew/twitter.png"
                      className="w-100 h-100"
                      alt=""
                    />
                  </a>
                </li>
                <li>
                  <a href="">
                    <img
                      src="assets/imagesnew/telegram.png"
                      className="w-100 h-100"
                      alt=""
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
